import * as React from "react";
import { cn } from "@/lib/utils";
import { fieldSizes, fieldStyles, type FieldSize } from "./fieldStyles";
import { useFieldControlProps } from "./FormGroup";

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  /** Default "md" (44px). */
  size?: FieldSize;
  /** Error state. Set automatically inside a <FormGroup error>. */
  invalid?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ size = "md", invalid, className, type = "text", ...props }, ref) => {
    const controlProps = useFieldControlProps(props, invalid);
    return (
      <input
        ref={ref}
        type={type}
        className={cn(fieldStyles, fieldSizes[size], className)}
        {...controlProps}
      />
    );
  },
);
Input.displayName = "Input";
